export function formatCountdownMs(timeLeftMs: number): string {
  const safeMs = Number.isFinite(timeLeftMs) ? Math.max(0, timeLeftMs) : 0;
  const totalSeconds = Math.max(0, Math.ceil(safeMs / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${minutes.toString().padStart(2, '0')}:${seconds
    .toString()
    .padStart(2, '0')}`;
}
